import { NavLink, Link, useLocation } from 'react-router-dom';
import { LogOut } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { LanguageToggle } from './LanguageToggle';
import { signOut } from 'firebase/auth';
import { auth } from '../lib/firebase';
import clsx from 'clsx';

export const TopNav = () => {
    const { t } = useLanguage();
    const location = useLocation();

    const handleLogout = async () => {
        try {
            await signOut(auth);
        } catch (error) {
            console.error('Logout error:', error);
        }
    };

    const navLinks = [
        { path: '/dashboard', label: t('dashboard'), key: 'dashboard' },
        { path: '/sessions', label: t('sessions') || 'Sessions', key: 'sessions' },
        { path: '/active-game', label: t('navActiveGame'), key: 'active-game' },
        { path: '/community', label: t('navCommunity'), key: 'community' },
        { path: '/hospitality', label: t('hospitality'), key: 'hospitality' },
        { path: '/history', label: t('navHistory'), key: 'history' },
    ];

    return (
        <nav className="bg-gray-900 border-b border-gray-700 sticky top-0 z-50">
            <div className="max-w-7xl mx-auto px-2 sm:px-6 lg:px-8">
                <div className="flex flex-col md:flex-row md:items-center justify-between py-2 md:h-16 gap-2">
                    {/* Header Top - Logo + Mobile Actions */}
                    <div className="flex items-center justify-between w-full md:w-auto">
                        {/* Logo/Brand */}
                        <div className="flex-shrink-0 flex items-center gap-2">
                            <h1 className="text-xl md:text-2xl font-bold text-poker-gold">{t('appName')}</h1>
                        </div>

                        {/* Right side for mobile only */}
                        <div className="flex md:hidden items-center gap-2">
                            <LanguageToggle />
                            <button
                                onClick={handleLogout}
                                className="p-2 text-gray-400 hover:text-white hover:bg-gray-800 rounded-lg transition-colors"
                                aria-label="Logout"
                            >
                                <LogOut className="w-5 h-5" />
                            </button>
                        </div>
                    </div>

                    {/* Navigation Links - constrained for mobile */}
                    <div className="flex flex-nowrap items-center gap-1 md:gap-4 rtl:space-x-reverse w-full md:w-auto pb-1 md:pb-0 overflow-x-auto no-scrollbar scroll-smooth">
                        {navLinks.map((link) => (
                            <NavLink
                                key={link.key}
                                to={link.path}
                                className={({ isActive }) => clsx(
                                    "px-2 md:px-3 py-1 rounded-lg font-bold transition-all duration-300 whitespace-nowrap text-[clamp(0.6rem,1.2vw,0.8125rem)]",
                                    isActive 
                                        ? "bg-amber-500 text-slate-950 shadow-lg shadow-amber-500/20 scale-105" 
                                        : "text-slate-400 hover:text-amber-400 hover:bg-white/5"
                                )}
                            >
                                {link.label}
                            </NavLink>
                        ))}
                    </div>

                    {/* Right side for desktop only */}
                    <div className="hidden md:flex items-center gap-3">
                        <LanguageToggle />
                        <button
                            onClick={handleLogout}
                            className="p-2 text-gray-400 hover:text-white hover:bg-gray-800 rounded-lg transition-colors"
                            aria-label="Logout"
                        >
                            <LogOut className="w-5 h-5" />
                        </button>
                    </div>
                </div>
            </div>
        </nav>
    );
};
